import styled, { css } from 'styled-components';
import theme from '|/components/base/theme';

const toastStyles = css`
  .notification-container {
    box-sizing: border-box;
    position: fixed;
    z-index: 999999;
    display: flex;
    flex-direction: row;
    border-radius: 3px;
  }

  .background-white {
    background-color: white;
  }

  .top-right {
    top: 15px;
    right: 15px;
    transition: transform 0.6s ease-in-out;
    animation: toast-in-right 0.7s;
  }

  .bottom-right {
    bottom: 15px;
    right: 15px;
    transition: transform 0.6s ease-in-out;
    animation: toast-in-right 0.7s;
  }

  .top-left {
    top: 15px;
    left: 15px;
    transition: transform 0.6s ease-in;
    animation: toast-in-left 0.7s;
  }

  .bottom-left {
    bottom: 15px;
    left: 15px;
    transition: transform 0.6s ease-in;
    animation: toast-in-left 0.7s;
  }

  .close-small {
    margin: 15px;
    color: #757989;
  }

  .notification {
    background: #fff;
    transition: 0.3s ease;
    pointer-events: auto;
    overflow: hidden;
    padding: 30px;
    min-width: 100px;
    max-height: 100px;
    border-radius: 3px;
    color: #000;
    display: flex;
    flex-direction: row;
    align-items: center;
    cursor: pointer;
  }

  .notification-title {
    font-weight: 700;
    font-size: 1rem;
    text-align: left;
    margin-top: 0;
    width: 300px;
    height: 18px;
  }

  .notification-message {
    margin: 0;
    line-height: 20px;
    font-size: 1rem;
    text-align: left;
    margin-left: -1px;
  }

  .notification-image {
    float: left;
    margin-right: 15px;
  }

  .notification-close {
    float: right;
    margin-right: 15px;
    margin-left: 15px;
    cursor: pointer;
  }

  .toast {
    min-height: 56px;
    color: #fff;
    padding: 15px 0px 10px 10px;
  }

  .success {
    background-color: #1dd08b;
  }

  .error {
    background-color: #ff7171;
  }

  .info {
    background-color: #00aed9;
  }

  .warning {
    background-color: #feb948;
  }

  .retry-link {
    ${theme.font.link.s}
    text-decoration: underline;
    cursor: pointer;
  }

  @keyframes toast-in-right {
    from {
      transform: translateX(100%);
    }
    to {
      transform: translateX(0);
    }
  }

  @keyframes toast-in-left {
    from {
      transform: translateX(-100%);
    }
    to {
      transform: translateX(0);
    }
  }

  @media screen and (max-width: 375px) {
    .notification-container {
      max-width: 343px;
      height: 128px;
    }
  }

  @media screen and (max-width: 500px) {
    .notification-message {
      max-width: 275px;
    }
  }

  @media screen and (min-width: 768px) {
    .top-left {
      left: 332px;
    }

    .bottom-left {
      left: 332px;
    }
  }

  @media screen and (min-width: 1280px) {
    .top-left {
      left: 351px;
    }

    .bottom-left {
      left: 351px;
    }
  }

  @media screen and (min-width: 1440px) {
    .top-left {
      left: 399px;
    }

    .bottom-left {
      left: 399px;
    }
  }

  @media screen and (min-width: 1800px) {
    .top-left {
      left: calc((336px + 100vw) - 1800px);
    }

    .bottom-left {
      left: calc((336px + 100vw) - 1800px);
    }
  }
`;

export const NotificationContainer = styled.div`
  ${toastStyles}
`;
